import { Helmet } from 'react-helmet'
import BackgroundSlider from './BackgroundSlider'

const Wrapper = () => (
  <>
    <Helmet>
      <meta charSet='utf-8' />
      <title>Background Slider</title>
    </Helmet>
    <BackgroundSlider />
  </>
)
export default Wrapper
